import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';

export interface VipCardProps {
  isVip?: boolean;
  vipExpiresAt?: string | null;
  onUpgrade?: () => void;
}

const VipCard: React.FC<VipCardProps> = ({ isVip, vipExpiresAt, onUpgrade }) => {
  return (
    <TouchableOpacity activeOpacity={isVip ? 1 : 0.8} style={[styles.container, !isVip && styles.upgrade]} onPress={() => { if (!isVip && onUpgrade) onUpgrade(); }}>
      <View style={styles.header}>
        <Text style={[styles.title, !isVip && styles.upgradeTitle]}>{isVip ? 'VIP Privileges' : 'Upgrade to VIP'}</Text>
      </View>

      <Text style={[styles.desc, !isVip && styles.upgradeDesc]}>
        {isVip ? 'Enjoy additional features and priority support.' : 'Try VIP for extra features and special trial offers.'}
      </Text>

      {isVip && vipExpiresAt ? (
        <Text style={styles.expiry}>Valid until: {new Date(vipExpiresAt).toLocaleDateString()}</Text>
      ) : null}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: { padding: 20, borderRadius: 12, backgroundColor: '#FFF8E1', borderWidth: 1, borderColor: '#F7931E', marginBottom: 16 },
  header: { flexDirection: 'row', alignItems: 'center', marginBottom: 8 },
  title: { fontSize: 18, fontWeight: '700', color: '#F7931E' },
  desc: { fontSize: 14, color: '#666' },
  expiry: { marginTop: 8, fontSize: 12, color: '#999' },
  upgrade: { backgroundColor: '#F0F7FF', borderColor: '#4A86F7' },
  upgradeTitle: { color: '#4A86F7' },
  upgradeDesc: { color: '#4A86F7' },
});

export default VipCard;
